'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogSingle = void 0;
const $ = require("jquery");
class BlogSingle {
    constructor() {
        const self = this;
        // 画像のリンクを拾ってボックスをリンクに変える
        const PostTitles = $('.trigPostTitleH0');
        if (PostTitles.length > 0) {
            for (let i = 0; i < PostTitles.length; i++) {
                const PostTitle = PostTitles.eq(i);
                // パンくずリスト span タグ内のタグを削除
                PostTitle.replaceWith(PostTitle.find('h6').html());
            }
        }
    }
}
exports.BlogSingle = BlogSingle;
exports.default = BlogSingle;
